import React, { useState, useCallback, memo, useEffect } from "react";
import { axiosInstanceMain } from "../../utils/axiosGlobalUtils";

// components
import {
  Box,
  Button,
  Divider,
  useTheme,
  useMediaQuery,
  Grid,
} from "@mui/material";

// redux
import { connect } from "react-redux";
import setRedirectUrl from "../../redux/actions/redirection/setRedirectUrl";
import Navbar from "../../components/Navbar";
import Footer from "../Home/components/Footer";
import Calificaciones from "../../components/AdminLocal/AdminLocalCalificaciones";
import ModalCalificaciones from "../../components/AdminLocal/ModalCalificaciones";
import { useCalificaciones } from "./calificaciones.hook";

const CalificacionesVendedor: React.FC = (props: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const idLocal = props.logged.userLogged.idLocal;
  const { calificacionesList, calificacionXatributoList } = useCalificaciones(idLocal);

  return (
    <>
      <Navbar title={`Mis Calificaciones`} />
      <Grid
        container
        direction={isMobile ? "column" : "row"}
        id="calificaciones-grid"
      >
        <Grid item xs={12} md={6}>
          <Calificaciones idLocal={idLocal} isAdmin={false}/>
        </Grid>
        <Grid item xs={12} md={6}>
          <ModalCalificaciones idLocal={idLocal} options={calificacionXatributoList} data={calificacionesList} isAdmin={false} />
        </Grid>
      </Grid>
      {!isMobile && (
        <div
          style={{
            position: "relative",
            width: "100%",
            bottom: 0,
          }}
        >
          <Footer />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection,
  };
};

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(CalificacionesVendedor));
